{
    "endpoints": [
        {
            "endpoint": "ms-security/api/user/{username}/role",
            "pattern": "ms-security\\/api\\/user\\/[^\\/]+/role"
        },
        {
            "endpoint": "ms-security/api/user/{username}/partner",
            "pattern": "ms-security\\/api\\/user\\/[^\\/]+/partner"
        },
        {
            "endpoint": "ms-.*?/api/status/ready",
            "pattern": "ms-[^\\/]+\\/api\\/status\\/ready"
        },
        {
            "endpoint": "ms-.*?/api/configProperty/key/{configKey}/bool",
            "pattern": "ms-[^\\/]+\\/api\\/configProperty\\/key\\/[^\\/]+/bool",
            "errors": [
                {
                    "responseStatus": 500,
                    "codes": ["orcan.configs.configproperty.not-found"]
                }
            ]
        },
        {
            "endpoint": "healthz",
            "pattern": "healthz"
        },
        {
            "endpoint": "ms-specialorders/api/specialOrder/report/search",
            "pattern": "ms-specialorders\\/api\\/specialOrder\\/report\\/search",
            "errors": [
                {
                    "responseStatus": 400,
                    "codes": [
                        "orcan.specialorderreport.specialorder.material.delivery.max-result-number-exceed"
                    ]
                }
            ]
        },
        {
            "endpoint": "ms-claims/api/claim/{claimNumber}/submit",
            "pattern": "ms-claims\\/api\\/claim\\/[^\\/]+/submit",
            "errors": [
                {
                    "responseStatus": 500,
                    "codes": [
                        "orcan.claims.service.handling-unit.service-unavailable",
                        "orcan.claims.service.file-manager.service-unavailable"
                    ]
                }
            ]
        },
        {
            "endpoint": "ms-claims/api/claim/{claimNumber}/submit",
            "pattern": "ms-claims\\/api\\/claim\\/[^\\/]+/submit",
            "errors": [
                {
                    "responseStatus": 400,
                    "codes": [
                        "orcan.claims.claim.send.sap.data.hu-invalid",
                        "orcan.claims.claim.send.sap.data.missing"
                    ]
                }
            ]
        },
        {
            "endpoint": "ms-claims/api/claim/report/search",
            "pattern": "ms-claims\\/api\\/claim\\/report\\/search",
            "errors": [
                {
                    "responseStatus": 400,
                    "codes": [
                        "orcan.claims.claim.position.max-result-number-exceed"
                    ]
                }
            ]
        },
        {
            "endpoint": "ms-claims/api/handlingUnit/validate",
            "pattern": "ms-claims\\/api\\/handlingUnit\\/validate",
            "errors": [
                {
                    "responseStatus": 500,
                    "codes": [
                        "orcan.claims.service.handling-unit.service-unavailable"
                    ]
                }
            ]
        },
        {
            "endpoint": "ms-filemanager/api/folders/{folder}/files",
            "pattern": "ms-filemanager\\/api\\/folders\\/[^\\/]+/files"
        },
        {
            "endpoint": "ms-filemanager/api/folders",
            "pattern": "ms-filemanager\\/api\\/folders$"
        },
        {
            "endpoint": "ms-filemanager/api/folders/{folder}/clone",
            "pattern": "ms-filemanager\\/api\\/folders\\/[^\\/]+/clone"
        },
        {
            "endpoint": "ms-filemanager/api/config",
            "pattern": "ms-filemanager\\/api\\/config"
        },
        {
            "endpoint": "ms-settings/api/schema/{SCHEMA_VERSION}/business/${BUSINESS_SETTINGS_VERSION}/submit",
            "pattern": "ms-settings\\/api\\/schema\\/[^\\/]+/business\\/[^\\/]+/submit"
        },
        {
            "endpoint": "ms-specialorders/api/specialOrder/material/validate",
            "pattern": "ms-specialorders\\/api\\/specialOrder\\/material\\/validate",
            "errors": [
                {
                    "responseStatus": 400,
                    "codes": [
                        "orcan.specialorders.specialorder.material.too-many-positions"
                    ]
                }
            ]
        },
        {
            "endpoint": "ms-partnumberchanges/api/partNumberChange/report/search",
            "pattern": "ms-partnumberchanges\\/api\\/partNumberChange\\/report\\/search",
            "errors": [
                {
                    "responseStatus": 400,
                    "codes": [
                        "orcan.partnumberchanges.partnumberchange.max-result-number-exceed"
                    ]
                }
            ]
        },
        {
            "endpoint": "ms-partnumberchanges/api/partNumberChange/report/search/toDo",
            "pattern": "ms-partnumberchanges\\/api\\/partNumberChange\\/report\\/search/toDo",
            "errors": [
                {
                    "responseStatus": 400,
                    "codes": [
                        "orcan.partnumberchanges.partnumberchange.max-result-number-exceed"
                    ]
                }
            ]
        },
        {
            "endpoint": "ms-partnumberchanges/api/partNumberChange/report/search/myList",
            "pattern": "ms-partnumberchanges\\/api\\/partNumberChange\\/report\\/search/myList",
            "errors": [
                {
                    "responseStatus": 400,
                    "codes": [
                        "orcan.partnumberchanges.partnumberchange.max-result-number-exceed"
                    ]
                }
            ]
        },
        {
            "endpoint": "ms-settlements/api/settlement/customer/report/search",
            "pattern": "ms-settlements\\/api\\/settlement\\/customer\\/report\\/search",
            "errors": [
                {
                    "responseStatus": 400,
                    "codes": [
                        "orcan.settlements.settlement.max-result-number-exceed"
                    ]
                }
            ]
        },
        {
            "endpoint": "ms-settlements/api/settlement/supplier/report/search",
            "pattern": "ms-settlements\\/api\\/settlement\\/supplier\\/report\\/search",
            "errors": [
                {
                    "responseStatus": 400,
                    "codes": [
                        "orcan.settlements.settlement.max-result-number-exceed"
                    ]
                }
            ]
        },
        {
            "endpoint": "ms-settlements/api/settlement/supplier/report/search/toDo",
            "pattern": "ms-settlements\\/api\\/settlement\\/supplier\\/report\\/search/toDo",
            "errors": [
                {
                    "responseStatus": 400,
                    "codes": [
                        "orcan.settlements.settlement.max-result-number-exceed"
                    ]
                }
            ]
        },
        {
            "endpoint": "ms-settlements/api/settlement/customer/report/search/toDo",
            "pattern": "ms-settlements\\/api\\/settlement\\/customer\\/report\\/search/toDo",
            "errors": [
                {
                    "responseStatus": 400,
                    "codes": [
                        "orcan.settlements.settlement.max-result-number-exceed"
                    ]
                }
            ]
        },
        {
            "endpoint": "ms-settings/api/alert/base/current",
            "pattern": "ms-settings\\/api\\/alert\\/base\\/current"
        }
    ]
}
